/* Compatible Vela cart API, with locale-aware routes and safe error handling. */
(function (window, $) {
  'use strict';
  var API = window.ShopifyAPI = window.ShopifyAPI || {};
  function route(path) { return ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/') + path; }
  function cartUrl() { return route('cart'); }
  function errorMessage(xhr) {
    var data = xhr && xhr.responseJSON;
    if (!data && xhr && xhr.responseText) { try { data = JSON.parse(xhr.responseText); } catch (ignore) {} }
    var message = data && (data.description || data.message);
    if (typeof message === 'string') return message;
    return 'Non è stato possibile verificare l’operazione. Controlla il carrello prima di riprovare.';
  }
  function announce($form, text, error) {
    var $message = $form.find('[data-er-form-message]');
    if (!$message.length) {
      $message = $('<p class="er-form-message" data-er-form-message role="status" aria-live="polite"></p>').appendTo($form);
    }
    $message.text(text).prop('hidden', false).toggleClass('is-error', Boolean(error));
    if (error) $('<a></a>').attr('href', cartUrl()).text(' Apri il carrello').appendTo($message);
  }
  API.onCartUpdate = API.onCartUpdate || function () {};
  API.onError = function (xhr) {
    var $host = $('#cartContainer');
    var $message = $host.find('[data-er-cart-error]');
    if (!$message.length) $message = $('<p class="er-form-message is-error" data-er-cart-error role="alert"></p>').prependTo($host);
    $message.text(errorMessage(xhr));
    $('<a></a>').attr('href', cartUrl()).text(' Apri il carrello').appendTo($message);
  };
  API.updateCartNote = function (note, callback) {
    return $.ajax({type:'POST',url:route('cart/update.js'),data:{note:String(note || '')},dataType:'json'})
      .done(function (cart) { (callback || API.onCartUpdate)(cart); }).fail(API.onError);
  };
  API.getCart = function (callback, errorCallback) {
    return $.ajax({url:route('cart.js'),dataType:'json',cache:false})
      .done(function (cart) { (callback || API.onCartUpdate)(cart); })
      .fail(function (xhr) { $('body').removeClass('ajaxcartIsLoading drawerIsLoading'); (errorCallback || API.onError)(xhr); });
  };
  API.addItemFromForm = function (form, callback, errorCallback) {
    return $.ajax({type:'POST',url:route('cart/add.js'),data:new FormData(form),contentType:false,processData:false,dataType:'json'})
      .done(function (item) { if (callback) callback(item, form); })
      .fail(function (xhr) { if (errorCallback) errorCallback(form, xhr); else API.onError(xhr); });
  };
  API.changeItem = function (line, quantity, callback, errorCallback) {
    return $.ajax({type:'POST',url:route('cart/change.js'),data:{line:line,quantity:quantity},dataType:'json'})
      .done(function (cart) { (callback || API.onCartUpdate)(cart); }).fail(errorCallback || API.onError);
  };
  var settings = {}, isUpdating = false;
  function format(cents) { return Shopify.formatMoney(cents, settings.moneyFormat || window.money); }
  function cleanProperties(properties) {
    var result = {};
    Object.keys(properties || {}).forEach(function (key) {
      if (key.charAt(0) !== '_' && properties[key] !== null && properties[key] !== '') result[key] = String(properties[key]);
    });
    return result;
  }
  function itemData(item, index) {
    var finalPrice = item.final_price === undefined ? item.price : item.final_price;
    var originalPrice = item.original_price === undefined ? item.price : item.original_price;
    return {
      id:item.variant_id, line:index+1, key:item.key, url:item.url,
      img:item.image || '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif',
      name:item.product_title, variation:item.variant_title === 'Default Title' ? null : item.variant_title,
      properties:cleanProperties(item.properties), vendor:item.vendor, itemQty:item.quantity,
      itemAdd:item.quantity+1, itemMinus:Math.max(0,item.quantity-1), price:format(finalPrice),
      originalPrice:originalPrice > finalPrice ? format(originalPrice) : null,
      linePrice:format(item.final_line_price === undefined ? item.line_price : item.final_line_price),
      discounts:(item.line_level_discount_allocations || []).map(function (allocation) { return {title:allocation.discount_application.title,amount:format(allocation.amount)}; }),
      sellingPlan:item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : null
    };
  }
  function counts(cart) {
    $(settings.cartCountSelector || '#CartCount').text(cart.item_count).toggleClass('hidden-count', cart.item_count === 0);
    if (settings.cartCostSelector) $(settings.cartCostSelector).html(format(cart.total_price));
  }
  function render(cart) {
    var $container = $(settings.cartContainer || '#cartContainer');
    counts(cart);
    if (!cart.item_count) {
      $container.empty();
      var $empty = $('<div class="drawerCartEmpty"></div>').appendTo($container);
      $('<p></p>').text(window.cart_empty || 'Il carrello è vuoto.').appendTo($empty);
      $('<a class="er-button er-button--dark"></a>').attr('href',route('collections/all')).text('Scopri il catalogo').appendTo($empty);
    } else {
      var source = $(window.ajaxcart_type === 'modal' ? '#headerCartTemplate' : '#CartTemplate').html();
      if (!source || !window.Handlebars) { API.onError(null); return; }
      var data = {
        items:cart.items.map(itemData), note:cart.note, totalPrice:format(cart.total_price),
        discounts:(cart.cart_level_discount_applications || []).map(function (discount) { return {title:discount.title,amount:format(discount.total_allocated_amount)}; })
      };
      $container.html(Handlebars.compile(source)(data));
    }
    $('body').removeClass('ajaxcartIsLoading drawerIsLoading');
    $('body').trigger('ajaxCart.afterCartLoad', cart);
    if (window.Shopify && Shopify.StorefrontExpressButtons) Shopify.StorefrontExpressButtons.initialize();
  }
  function load() { $('body').addClass('ajaxcartIsLoading'); return API.getCart(render); }
  function submit(event) {
    if (window.ajaxcart_type === 'page' || settings.disableAjaxCart) return;
    event.preventDefault();
    var form = event.currentTarget, $form = $(form), $button = $form.find('button[type="submit"],input[type="submit"]');
    if ($form.data('erCartPending') || isUpdating) return;
    var main = form.querySelector('#AddToCart');
    if (main && main.disabled) return;
    if (form.checkValidity && !form.checkValidity()) { form.reportValidity(); return; }
    $form.data('erCartPending', true);
    $button.addClass('is-adding').attr('aria-busy','true');
    $form.find('[data-er-form-message]').prop('hidden',true);
    $('body').addClass('velaCartAdding');
    API.addItemFromForm(form, function () {
      $form.data('erCartPending', false);
      $button.removeClass('is-adding').addClass('is-added').attr('aria-busy','false');
      $('body').removeClass('velaCartAdding');
      announce($form, 'Aggiunto al carrello.', false);
      API.getCart(render, function (xhr) {
        announce($form, 'Prodotto aggiunto. Non è stato possibile aggiornare il riepilogo: apri il carrello per verificarlo.', true);
        API.onError(xhr);
      });
    }, function (target, xhr) {
      $form.data('erCartPending', false);
      $button.removeClass('is-adding is-added').attr('aria-busy','false');
      $('body').removeClass('velaCartAdding');
      announce($form, errorMessage(xhr), true);
    });
  }
  function setUpdating(updating) {
    isUpdating = updating;
    $('#cartContainer').attr('aria-busy',String(updating)).find('.qtyAdjust,.qtyNum,.cartRemove,.btnCheckout').prop('disabled',updating);
  }
  function update(line, quantity) {
    if (isUpdating || !Number.isInteger(quantity) || quantity < 0) return;
    setUpdating(true);
    API.changeItem(line, quantity, function (cart) { setUpdating(false); render(cart); }, function (xhr) { setUpdating(false); API.onError(xhr); });
  }
  function handlers() {
    var $body = $('body');
    $body.off('click.erCartQty','.qtyAdjust').on('click.erCartQty','.qtyAdjust',function () {
      var $button = $(this), $input = $button.siblings('.qtyNum');
      var quantity = Number($input.val());
      if (!Number.isInteger(quantity) || quantity < 0) quantity = 1;
      quantity = Math.max(0,quantity + ($button.hasClass('velaQtyPlus') ? 1 : -1));
      var line = Number($button.data('line'));
      if (line) update(line,quantity); else $input.val(quantity).trigger('change');
    });
    $body.off('change.erCartQty','.qtyNum').on('change.erCartQty','.qtyNum',function () {
      var line = Number($(this).data('line'));
      if (line) update(line, Number(this.value));
    });
    $body.off('click.erCartRemove','#cartContainer .cartRemove').on('click.erCartRemove','#cartContainer .cartRemove',function (event) {
      event.preventDefault(); update(Number($(this).data('line')),0);
    });
    $body.off('submit.erCartCheckout','form.ajaxcart').on('submit.erCartCheckout','form.ajaxcart',function (event) { if (isUpdating) event.preventDefault(); });
    $body.off('change.erCartNote','#cartContainer textarea[name="note"]').on('change.erCartNote','#cartContainer textarea[name="note"]',function () { API.updateCartNote(this.value); });
    $body.off('click.erLegacyQty','.velaQtyAdjust').on('click.erLegacyQty','.velaQtyAdjust',function () {
      var $input = $(this).siblings('.velaQtyNum');
      var value = Number($input.val()) || 1;
      $input.val(Math.max(1,value + ($(this).hasClass('velaQtyPlus') ? 1 : -1))).trigger('change');
    });
  }
  function quantitySelectors() {
    // Never transform filter prices, native cart fields, or the main product input.
    $('input[type="number"][name="quantity"]:not([data-er-native-quantity])').each(function () {
      var $input = $(this), source = $('#velaJsQty').html();
      if (!source) return;
      var quantity = Number($input.val()) || 1;
      $input.after(Handlebars.compile(source)({itemQty:quantity,itemAdd:quantity+1,itemMinus:Math.max(1,quantity-1),inputName:$input.attr('name'),inputId:$input.attr('id'),id:$input.data('id')})).remove();
    });
  }
  window.ajaxCart = {
    init:function (options) {
      settings = $.extend({formSelector:'.formAddToCart',cartContainer:'#cartContainer',cartCountSelector:'#CartCount',cartCostSelector:'#CartCost',moneyFormat:window.money,enableQtySelectors:true,disableAjaxCart:false},options);
      $('body').off('submit.erCart',settings.formSelector).on('submit.erCart',settings.formSelector,submit);
      if (settings.enableQtySelectors) quantitySelectors();
      handlers();
    },
    load:load
  };
  $(function () { window.ajaxCart.init({formSelector:'.formAddToCart',cartContainer:'#cartContainer',addToCartSelector:'.btnAddToCart',cartCountSelector:'#CartCount',cartCostSelector:'#CartCost',moneyFormat:window.money}); });
}(window, jQuery));
